module.exports = "/assets/data/f47aa2445fc341b0895e1ee3cdeb8330-BS32.data.json";